import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import getData from '../../api/queries/getData';
import { selectActiveTicket, setData } from '../../redux/data/dataSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { store } from '../../redux/store';

const useData = () => {
  const user = store.getState().auth.user;
  const activeTicket = useAppSelector(selectActiveTicket);

  const { data, isLoading, isSuccess, error, refetch } = useQuery({
    queryKey: ['getData', user?.activeStore?._id, activeTicket?.customerId],
    enabled: !!user && !!user?.activeStore?._id,
    queryFn: () =>
      user?.activeStore?._id ? getData(user.activeStore._id, activeTicket?.customerId) : null,
  });

  return {
    // Modifiers
    data,
    isLoading,
    isSuccess,
    error: error,
    refetch,
  };
};

const useDataStoreSetter = () => {
  const { data, refetch, isLoading, isSuccess } = useData();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data && isSuccess) {
      dispatch(setData(data));
    }
  }, [isSuccess, data]);

  return { data, isLoading, refetch };
};

export { useData, useDataStoreSetter };
